

import {Action} from '@ngrx/store';

export const GET_BENUTZER_LISTE_ADMIN_EXCEL = '[BenutzerverwaltungModul] GetBenutzerListeAdminExcel laden';
export const GET_BENUTZER_LISTE_ADMIN_EXCEL_AUSFUEHREN = '[BenutzerverwaltungModul] GetBenutzerListeAdminExcel ausführen';
export const GET_BENUTZER_LISTE_ADMIN_EXCEL_ERFOLGREICH = '[BenutzerverwaltungModul] GetBenutzerListeAdminExcel laden erfolgreich';
export const GET_BENUTZER_LISTE_ADMIN_EXCEL_FEHLER = '[BenutzerverwaltungModul] GetBenutzerListeAdminExcel Ladefehler';
export const GET_BENUTZER_LISTE_ADMIN_EXCEL_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] GetBenutzerListeAdminExcel nicht ausgeführt (evtl. Offline)';


export class GetBenutzerListeAdminExcelAction implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN_EXCEL;
        constructor(public optPayload: any = null) {}
    }
export class GetBenutzerListeAdminExcelAusfuehrenAction implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN_EXCEL_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetBenutzerListeAdminExcelErfolgreichAction implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN_EXCEL_ERFOLGREICH;
        constructor(public payload: string, public optPayload: any = null) {}
    }
export class GetBenutzerListeAdminExcelFehlerAction implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN_EXCEL_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetBenutzerListeAdminExcelNichtAusgefuehrtAction implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN_EXCEL_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungQueryBenutzerListeAdminExcelActions =
    GetBenutzerListeAdminExcelAction
    | GetBenutzerListeAdminExcelAusfuehrenAction
    | GetBenutzerListeAdminExcelErfolgreichAction
    | GetBenutzerListeAdminExcelFehlerAction
    | GetBenutzerListeAdminExcelNichtAusgefuehrtAction
    ;
